import type { Terminal, VinculationEntry } from './POS';

// ─── Payfac & Seller types ────────────────────────────────────────────────────

export interface Payfac {
  id: string;
  name: string;
}

export interface Seller {
  id: string;
  name: string;
  payfacId: string;
}

// ─── Name lists ───────────────────────────────────────────────────────────────

const PAYFAC_NAME_LIST: string[] = [
  'Barte Pagamentos', 'FinTech BR', 'PayNow Brasil', 'Nexus Pagamentos', 'Agile Pay',
  'Smart Soluções', 'Digital Pay', 'TechPay Brasil', 'Flex Pagamentos', 'Flow Financeira',
  'Rapid Pay', 'Prime Pagamentos', 'Core Pay', 'Open Finance', 'Fast Pay',
  'Cloud Pagamentos', 'UniPay', 'Total Pay', 'MaxPay Brasil', 'Pro Pagamentos',
  'Link Pay', 'Base Financeira', 'Plus Pay', 'Net Pagamentos', 'Go Pay',
  'Apex Soluções', 'Vero Pay', 'Pago Fácil', 'PayBridge', 'MegaPay BR',
  'Pronto Pago', 'PayCore', 'TopPay', 'ZenPay', 'BancoPay BR',
  'PayFlex', 'PaySmart', 'AgilePay', 'PayTech', 'Conexão Pay',
  'Rede Financeira', 'PayMax', 'Valore Pay', 'MasterPay BR', 'ePay Brasil',
  'FastFinance', 'iPayBR', 'PayGo', 'PayBase', 'UniFinance',
  'SolPay', 'MobiPay', 'CashPay', 'ZeroTax', 'PayNord',
  'PaySul', 'PayLeste', 'PayOeste', 'CentroPay', 'BrasilPay',
  'PagRápido', 'PagFácil', 'PagDigital', 'PagNet', 'PagOnline',
  'FinançaFácil', 'DigitPay', 'SmartFinance', 'TechFinance', 'CloudFinance',
  'RapidFinance', 'CoreFinance', 'OpenPay', 'MegaFinance', 'NovoPay',
  'NovaPay', 'VivaPay', 'AltaPay', 'LuzPay', 'SolPagamentos',
  'CapitalPay', 'InvestPay', 'WealthPay', 'GoldPay', 'PrimePay',
  'SeguroPay', 'ConfiaPay', 'FideliPay', 'LoyalPay', 'TrustPay',
  'EcoPay', 'GreenPay', 'CleanPay', 'PurePay', 'NaturePay',
  'TechSol', 'PaySol', 'FinSol', 'BizPay', 'TradesPay',
  'MerchantPay', 'RetailPay', 'ShopPay', 'StorePay', 'MarketPay',
  'MicroPay', 'NanoPay', 'AtomPay', 'BytePay', 'DataPay',
  'PayHub', 'PayPortal', 'PayGate', 'PayCenter', 'PayPoint',
  'InstantPay', 'ExpressPay', 'UltraPay', 'TurboPay', 'SpeedPay',
  'PayWave', 'PayPulse', 'PayStream', 'PayFlow', 'PayLink',
];

const SELLER_NAME_LIST: string[] = [
  'Loja Central LTDA', 'Mercado Bom Preço', 'Farmácia Saúde & Vida', 'Restaurante Sabor Bom', 'Posto Combustível Star',
  'Academia FitLife', 'Padaria Pão Quente', 'TechStore Informática', 'Supermercado Família', 'Livraria Cultura',
  'Ótica Visão Clara', 'Pet Shop Animal Love', 'Consultório Dr. Lima', 'Sorveteria Gelato', 'Auto Peças Brasil',
  'Hortifruti Verde Vida', 'Mercado do Bairro', 'Restaurante Beira Mar', 'Bar do Zé', 'Pizzaria Napolitana',
  'Açougue Bom Corte', 'Papelaria Estudo', 'Salão de Beleza Top', 'Laundry Express', 'Escola de Dança',
  'Clínica Dental Sorrir', 'Estúdio Fotográfico', 'Loja de Brinquedos', 'Hamburgueria Smash', 'Sapataria Conforto',
  'Padaria do João', 'Mercearia São Paulo', 'Confeitaria Doce Mel', 'Floricultura Perfume', 'Vidraçaria Brilho',
  'Ferragem Central', 'Loja de Tecidos', 'Camisaria Elegante', 'Joalheria Ouro Velho', 'Relojoaria Pontual',
  'Materiais de Construção ABC', 'Loja de Informática Plus', 'Assistência Técnica GX', 'Conserto de Celulares', 'Chaveiro 24h',
  'Petisqueira do Bira', 'Bar e Lanches Central', 'Lanchonete Ponto G', 'Café Aroma', 'Doceria Mel e Leite',
  'Distribuidora de Bebidas', 'Empório Gourmet', 'Adega Premium', 'Tabacaria Central', 'Lotérica da Sorte',
  'Centro Médico São Lucas', 'Clínica Veterinária', 'Pet Grooming Plus', 'Banho & Tosa', 'Aquário dos Peixes',
  'Livraria São Paulo', 'Papelaria & Arte', 'CD & DVD Store', 'Loja de Música', 'Luthieria Cordas & Notas',
  'Supermercado Express', 'Mercearia Familiar', 'Mini Mercado São Jorge', 'Quitanda do Pedro', 'Sacolão Verde',
  'Farmácia Popular', 'Drogaria Total', 'Farmácia 24 Horas', 'Drogaria Saúde', 'Manipulação Pharma',
  'Oficina Mecânica do João', 'Borracharia Central', 'Lava Jato VIP', 'Estofaria Conforto', 'Funilaria e Pintura',
  'Hotel Boutique Central', 'Pousada do Sol', 'Hostel Central', 'Imobiliária Lar Feliz', 'Serviços Condomínio',
  'Escola Particular Luz', 'Curso de Inglês Global', 'Academia de Artes', 'Studio de Yoga', 'CrossFit Box SP',
];

// ─── Payfacs & Sellers ────────────────────────────────────────────────────────

export const PAYFACS: Payfac[] = PAYFAC_NAME_LIST.map((name, i) => ({
  id: `PAYFAC-${String(i + 1).padStart(3, '0')}`,
  name,
}));

// 2 sellers per payfac for the first 45 payfacs (indices 0–44)
// seller index i → payfac index Math.floor(i/2)
export const SELLERS: Seller[] = SELLER_NAME_LIST.map((name, i) => ({
  id: `SEL-${String(i + 1).padStart(3, '0')}`,
  name,
  payfacId: PAYFACS[Math.floor(i / 2)].id,
}));

// ─── Lookup maps ──────────────────────────────────────────────────────────────

export const PAYFAC_NAMES: Record<string, string> = Object.fromEntries(
  PAYFACS.map((p) => [p.id, p.name]),
);

export const SELLER_NAMES: Record<string, string> = Object.fromEntries(
  SELLERS.map((s) => [s.id, s.name]),
);

export const SELLERS_BY_PAYFAC: Record<string, Seller[]> = SELLERS.reduce(
  (acc, s) => {
    (acc[s.payfacId] ??= []).push(s);
    return acc;
  },
  {} as Record<string, Seller[]>,
);

// ─── Select options ───────────────────────────────────────────────────────────

export const PAYFAC_OPTIONS = PAYFACS.map((p) => ({ value: p.id, label: p.name }));

export const ALL_SELLER_OPTIONS = SELLERS.map((s) => ({ value: s.id, label: s.name }));

export const SELLER_OPTIONS: Record<string, { value: string; label: string }[]> =
  Object.fromEntries(
    Object.entries(SELLERS_BY_PAYFAC).map(([payfacId, sellers]) => [
      payfacId,
      sellers.map((s) => ({ value: s.id, label: s.name })),
    ]),
  );

// ─── Terminal generation helpers ──────────────────────────────────────────────

const POS_VERSIONS = ['3.2.1', '3.2.1', '3.2.1', '3.2.0', '3.2.0', '3.1.0', '3.0.5'];

// Padrão: 4x Barte, 2x Própria, 2x Barte, repete a cada 8 terminais.
const OWNER_PATTERN: Terminal['owner'][] = [
  'Barte', 'Barte', 'Barte', 'Barte', 'Própria', 'Própria', 'Barte', 'Barte',
];

const RECENT_DATES = [
  '17/03/2026', '16/03/2026', '15/03/2026', '14/03/2026', '13/03/2026',
  '12/03/2026', '11/03/2026', '10/03/2026', '09/03/2026', '08/03/2026',
  '07/03/2026', '06/03/2026', '05/03/2026', '04/03/2026', '28/02/2026',
  '25/02/2026', '20/02/2026', '15/02/2026', '10/02/2026', '05/02/2026',
];

const RECENT_TIMES = [
  '08:05', '08:30', '09:10', '09:45', '10:15', '10:50', '11:20', '11:55',
  '12:30', '13:05', '13:40', '14:15', '14:50', '15:20', '15:55', '16:30',
  '17:05', '17:40', '18:15', '18:50',
];

// Converts a day-offset (from 01/01/2024) to 'dd/mm/yyyy' string.
// Uses 30-day months approximation; day is capped to 28.
function dateFromOffset(offset: number): string {
  let rem = Math.max(1, offset % 801);
  let year = 2024;
  while (rem > 365) { rem -= 365; year++; }
  let month = 1;
  const ML = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  for (const ml of ML) {
    if (rem <= ml) break;
    rem -= ml;
    month++;
  }
  const day = Math.max(1, Math.min(rem, 28));
  return `${String(day).padStart(2, '0')}/${String(month).padStart(2, '0')}/${year}`;
}

// Returns a date that is (5 + seed%25) days after dateStr (dd/mm/yyyy).
// Simple addition, caps day to 28, rolls month if > 28.
function daysAfter(dateStr: string, seed: number): string {
  const add = 5 + (seed % 25);
  const [d, m, y] = dateStr.split('/').map(Number);
  let dd = d + add, mm = m, yy = y;
  if (dd > 28) { dd -= 28; mm++; if (mm > 12) { mm = 1; yy++; } }
  return `${String(dd).padStart(2, '0')}/${String(mm).padStart(2, '0')}/${yy}`;
}

// ─── Terminal builder ─────────────────────────────────────────────────────────

function buildTerminals(): Terminal[] {
  const terminals: Terminal[] = [];

  for (let i = 0; i < 1250; i++) {
    const id           = `POS-${String(i + 1).padStart(4, '0')}`;
    const serialNumber = `SN-${String(2024000 + i + 1).padStart(8, '0')}`;
    const terminalId   = `TRM-${String(i + 1).padStart(4, '0')}`;
    const posVersion   = POS_VERSIONS[i % POS_VERSIONS.length];
    const owner: Terminal['owner'] = OWNER_PATTERN[i % OWNER_PATTERN.length];
    const registrationDate = dateFromOffset((i * 641) % 801);

    // defaults (overridden per-status)
    let payfac = '—', payfacId = '—', seller = '—', sellerId = '—';
    let lastTransaction = '—', vinculationDate = '—';
    let lastTestDate: string | undefined;
    let vinculationStartDate: string | undefined;
    let vinculationHistory: VinculationEntry[] | undefined;

    let status: Terminal['status'];

    if (i < 700) {
      // ── Alocada Lojista ──────────────────────────────────────────────────────
      status = 'Alocada Lojista';
      const payfacIdx = i % 45;
      const p = PAYFACS[payfacIdx];
      payfac = p.name; payfacId = p.id;
      const sellersForP = SELLERS_BY_PAYFAC[p.id]!;
      const s = sellersForP[i % 2];
      seller = s.name; sellerId = s.id;
      lastTransaction = `${RECENT_DATES[i % RECENT_DATES.length]} ${RECENT_TIMES[(i * 3) % RECENT_TIMES.length]}`;
      vinculationDate = daysAfter(registrationDate, i);
    } else if (i < 900) {
      // ── Estoque Intermediador ────────────────────────────────────────────────
      status = 'Estoque Intermediador';
      const p = PAYFACS[i % 125];
      payfac = p.name; payfacId = p.id;
      lastTestDate = daysAfter(registrationDate, 5 + (i % 6));
      vinculationStartDate = daysAfter(registrationDate, 12 + (i % 8));
    } else if (i < 1050) {
      // ── Estoque Barte ────────────────────────────────────────────────────────
      status = 'Estoque Barte';
      lastTestDate = daysAfter(registrationDate, 5 + (i % 10));
      if (i % 7 === 0) {
        vinculationHistory = [{
          payfac: PAYFACS[(i * 3) % 45].name,
          payfacId: PAYFACS[(i * 3) % 45].id,
          seller: '—', sellerId: '—', lastTransactionDate: '—',
          vinculationDate: daysAfter(registrationDate, 10),
          devinculationDate: daysAfter(registrationDate, 50),
        }];
      }
    } else if (i < 1150) {
      // ── Manutenção ───────────────────────────────────────────────────────────
      status = 'Manutenção';
      const p = PAYFACS[i % 45];
      payfac = p.name; payfacId = p.id;
      const sellersForP = SELLERS_BY_PAYFAC[p.id]!;
      const s = sellersForP[i % 2];
      seller = s.name; sellerId = s.id;
      lastTransaction = `${RECENT_DATES[(i * 7) % RECENT_DATES.length]} ${RECENT_TIMES[i % RECENT_TIMES.length]}`;
      vinculationDate = daysAfter(registrationDate, i % 20);
    } else if (i < 1225) {
      // ── Teste ────────────────────────────────────────────────────────────────
      status = 'Teste';
      // all defaults ('—')
    } else {
      // ── Desativada ───────────────────────────────────────────────────────────
      status = 'Desativada';
      lastTransaction = `${RECENT_DATES[i % RECENT_DATES.length]} ${RECENT_TIMES[(i * 2) % RECENT_TIMES.length]}`;
    }

    terminals.push({
      id,
      serialNumber,
      status,
      owner,
      payfac,
      payfacId,
      seller,
      sellerId,
      lastTransaction,
      vinculationDate,
      terminalId,
      posVersion,
      registrationDate,
      ...(lastTestDate !== undefined && { lastTestDate }),
      ...(vinculationStartDate !== undefined && { vinculationStartDate }),
      ...(vinculationHistory !== undefined && { vinculationHistory }),
    });
  }

  return terminals;
}

export const INITIAL_TERMINALS = buildTerminals();
